"use client";

import { IProjectData } from "@/types/strapi";
import { useState } from "react";
import ServiceGroup from "./service_group";
import ProjectArticle from "../_molecules/project_article";
import { List, ListTree, Rows3 } from "lucide-react";
import DisplayModeBtn from "../_atoms/displayModeBtn";

function ProjectsList({
	projects,
	orderedGroups,
}: {
	projects: IProjectData[];
	orderedGroups: [string, IProjectData[]][];
}) {
	const [displayMode, setDisplayMode] = useState<"list" | "category">("list");
	return (
		<section className="container">
			<div className="mb-10 flex items-center gap-4 text-sm text-gray-600 dark:text-gray-400">
				Afficher par :{" "}
				<DisplayModeBtn
					Icon={Rows3}
					mode="list"
					label="Liste"
					setDisplayMode={setDisplayMode}
					displayMode={displayMode}
				/>
				<DisplayModeBtn
					Icon={ListTree}
					mode="category"
					label="Catégories"
					setDisplayMode={setDisplayMode}
					displayMode={displayMode}
				/>
			</div>
			{displayMode === "list" ? (
				<ul className="grid gap-6 mb-20">
					{(projects as IProjectData[]).map((project) => (
						<li key={project.id}>
							<ProjectArticle project={project} />
						</li>
					))}
				</ul>
			) : (
				<section>
					{orderedGroups.map(([category, projects]) => (
						<ServiceGroup
							key={category}
							title={category}
							projects={projects}
						/>
					))}
				</section>
			)}
		</section>
	);
}

export default ProjectsList;
